package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SymptomLogDto(
    @SerialName("id") val id: String,
    @SerialName(FIELD_DATE) val date: Timestamp,
    @SerialName("symptoms") val symptoms: List<SymptomDto>,
) {
    companion object {
        const val FIELD_DATE = "timestamp"
    }
}

@Serializable
data class SymptomDto(
    @SerialName("kind") val kind: String,
    @SerialName("severity") val severity: String,
)
